
import React, { useState } from "react";
import LeftNav from "../common/LeftNav";
import TopNav from "../common/TopNav";
import "../../assets/styles/PersonalIDs.css"; 

import pencil from "../../assets/img/pencil.svg";
import personalleft from "../../assets/img/personal-left.svg";
// import personalleft from "../../assets/img/personal-left.svg";
import { useNavigate } from "react-router-dom";

export default function PersonalInformation() {
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);

  // Dummy data (replace later with API data)
  const [formData, setFormData] = useState({
    firstName: "Rajesh",
    lastName: "Sharma",
    email: "rajesh.sharma@gmail.com",
    phone: "+91 98765 43210",
    address: "Road no.2, Banjara Hills, Shangrila Plaza, opp KBR Park.",
    pincode: "500034",
    city: "Hyderabad",
    state: "Telangana",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="d-flex" style={{ background: "#fafbfc", minHeight: "100vh" }}>
      <LeftNav />
      <div className="main-content flex-grow-1">
        <TopNav />
        <div className="p-3">
          <div className="container-fluid px-4 py-3">
            <div className="card p-4 personal-ids-card">
              {/* Header */}
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h6 className="personal-head mb-0">
                  <img
                    src={personalleft}
                    style={{ cursor: "pointer" }}
                    className="me-2"
                    width={28}
                    height={28}
                    alt="back"
                    onClick={() => navigate(-1)}
                  />
                  Personal Information
                </h6>

                {!isEditing ? (
                  <button
                    className="border-0"
                    style={{ background: "none" }}
                    onClick={() => setIsEditing(true)}
                  >
                    <img src={pencil} width={20} height={20} alt="edit" />
                  </button>
                ) : (
                  <></>
                )}
              </div>

              {/* Form */}
              <div className="form-group mb-3">
                <label className="form-label personal-label">First Name</label>
                <input
                  type="text"
                  name="firstName"
                  className="form-control personal-input"
                  value={formData.firstName}
                  onChange={handleChange}
                  readOnly={!isEditing}
                />
              </div>

              <div className="form-group mb-3">
                <label className="form-label personal-label">Last Name</label>
                <input
                  type="text"
                  name="lastName"
                  className="form-control personal-input"
                  value={formData.lastName}
                  onChange={handleChange}
                  readOnly={!isEditing}
                />
              </div>

              <div className="form-group mb-3">
                <label className="form-label personal-label">Email ID</label>
                <input
                  type="email"
                  name="email"
                  className="form-control personal-input"
                  value={formData.email}
                  onChange={handleChange}
                  readOnly={!isEditing}
                />
              </div>

              <div className="form-group mb-3">
                <label className="form-label personal-label">Phone Number</label>
                <input
                  type="text"
                  name="phone"
                  className="form-control personal-input"
                  value={formData.phone}
                  onChange={handleChange}
                  readOnly={!isEditing}
                />
              </div>

              <div className="form-group mb-3">
                <label className="form-label personal-label">Address</label>
                <textarea
                  name="address"
                  className="form-control personal-input"
                  rows="2"
                  value={formData.address}
                  onChange={handleChange}
                  readOnly={!isEditing}
                ></textarea>
              </div>

              <div className="row">
                <div className="col-md-6 form-group mb-3">
                  <label className="form-label personal-label">Pincode</label>
                  <input
                    type="text"
                    name="pincode"
                    className="form-control personal-input"
                    value={formData.pincode}
                    onChange={handleChange}
                    readOnly={!isEditing}
                  />
                </div>

                <div className="col-md-6 form-group mb-3">
                  <label className="form-label personal-label">City</label>
                  <input
                    type="text"
                    name="city"
                    className="form-control personal-input"
                    value={formData.city}
                    onChange={handleChange}
                    readOnly={!isEditing}
                  />
                </div>
              </div>

              <div className="form-group mb-3">
                <label className="form-label personal-label">State</label>
                <input
                  type="text"
                  name="state"
                  className="form-control personal-input"
                  value={formData.state}
                  onChange={handleChange}
                  readOnly={!isEditing}
                />
              </div>

              {/* Save Button in edit mode */}
              {isEditing && (
                <div className="d-flex justify-content-end">
                  <button
                    className="personal-uspbtn d-flex justify-content-center align-items-center px-4"
                    onClick={() => setIsEditing(false)}
                    style={{ minWidth: "120px" }}
                  >
                    <span className="personal-uspbtntext">Save</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
